import ResultIcon from 'app/components/tests/result/ResultIcon';
import InputForm from 'app/commons/components/InputForm';
import * as testConst from 'app/constants/tests';
import { AppStoreState } from 'app/redux/store';
import { useSelector } from 'react-redux';
import { Question } from 'types/test';

interface QuestionInputProps {
  question: Question;
  groupType: number;
  className: string;
  confirmIsReady: () => void;
  handleChange: (value: string | null, question: Question) => void
}

const QuestionInput = (props: QuestionInputProps) => {
  if (props.groupType !== testConst.QUESTION_INPUT) return null;

  const { process } = useSelector((state: AppStoreState) => state.test);

  return (
    <div onClick={props.confirmIsReady} className="col-md-4 pl-0 pr-3 d-flex">
      <div style={{ width: '200px', flexShrink: 0 }}>
        <InputForm
          value={props.question.answer || ''}
          readOnly={['init', 'complete'].includes(process)}
          className={props.className}
          handleChange={(value: string) => props.handleChange(value, props.question)}
        />
      </div>

      <ResultIcon
        groupType={props.groupType}
        question={props.question}
      />
    </div>
  );
};

export default QuestionInput;
